import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import CashToClosePage from "@/pages/tools/CashToClose";

export const Route = createFileRoute("/tools/cash-to-close")({
  head: () => seoHead("/tools/cash-to-close"),
  component: CashToClosePage,
});
